import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AppContext } from '../../hooks';
import { Admin } from '../../pages/admin';
import { Home } from '../../pages/Home';
import { ProtectedRoute } from '../../Routes/Route';
import { Container } from './styles';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient();

const App = () => (
  <AppContext>
    <Container>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="admin/*"
              element={
                <ProtectedRoute redirectPath="/">
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </Container>
  </AppContext>
);

export default App;
